import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience } from "./isEnabledForFrontierCopilotAudience";

export function isFocusBlockSourceEventEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("time-copilot-focus-block-source-event") ||
        isFocusBlockSourceEventFrontierEnabled(mailboxInfo));
}

export function isFocusBlockSourceEventFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: "time-copilot-focus-block-source-event-frontier-public",
        privateTapFlight: "time-copilot-focus-block-source-event-frontier-private-tap",
        privateStagingFlight: "time-copilot-focus-block-source-event-frontier-private-staging",
        privateInfluencerFlight: "time-copilot-focus-block-source-event-frontier-private-influencer",
    });
}
